var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
})));
export default __webpack_public_path__ + "static/media/mais.f89f5f84.svg";
export { SvgComponent as ReactComponent };